
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verified-contracts",
      function () {
        return require("private-next-pages/verified-contracts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verified-contracts"])
      });
    }
  